<template>
	<div class="buy-car">
		<!-- <Header title="购物车" isback="" background="white" /> -->
		<div class="content">
			<template v-for="item in list">
				<div v-if="item.goods" class="flex-center list-item"  :key="item.id" @click="$router.push(`/classify/commodity/details/${item.goodsId}`)">
					<span class="noShelves" v-if="item.goods.onOffer==0">已下架</span>
					<img :src="selList.includes(item.goodsId) ? chose : nochose" alt="" class="icon"
						@click.stop="choseIt(item)" v-else />
					<img :src="item.goods.thumb" alt="" class="product-icon" />
					<div class="right-box">
						<p class="title">{{ item.goods.title }}</p>
						<p class="price">{{ item.goods.marketPrice }}日元({{ item.goods.realPrice }}人民币)</p>
						<img src="../../assets/img/car/del@2x.png" alt="" class="icon del" @click.stop="del(item.id)" />
					</div>
				</div>
			</template>
			
		</div>
		<div class="bottom-bar">
			<div class="carTips">{{tips}}</div>
			<div class="flex-between">
				<!-- <p class="flex-center" @click="choose">
					<img :src="allSelect ? chose : nochose" alt="" class="icon" />
					<span class="grey-text">全选</span>
				</p> -->
				<div class="flex-center">
					<span class="grey-text">共1件，</span>
					<span>合计：</span>
					<span class="red-text">￥{{allPrice.toFixed(2)}}</span>
				</div>
			</div>
			<div class="button" @click="settlement(selList.length)">结算（{{selList.length}}）</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "",
		data() {
			return {
				chose: require("../../assets/img/car/chose@2x.png"),
				nochose: require("../../assets/img/car/no-chose.png"),
				allSelect: false,
				selList: [],
				carIds: [],
				list: [],
				allPrice: 0,
				tips: ""
			};
		},
		pass: true,
		computed: {},
		mounted() {
			this.selAll()
		},
		watch: {
			selList(val) {
				this.allPrice = 0;
				for (let i = 0; i < val.length; i++) {
					for (let j = 0; j < this.list.length; j++) {
						if (val[i] == this.list[j].goodsId) {
							this.allPrice += this.list[j].goods.realPrice * 1
						}
					}
				}
			}
		},
		methods: {
			settlement(length) {
				console.log(length,"length");
				if(length <= 0) {
					this.$toast("请选择要支付的商品，一次结算一件");
					return;
				} else if(length > 1) {
					this.$toast("请一次结算一件");
					return;
				}
				let info = encodeURIComponent(
					JSON.stringify(this.selList)
				);
				let carIds = encodeURIComponent(
					JSON.stringify(this.carIds)
				);
				this.$router.push(`/classify/commodity/order?info=${info}&carIds=${carIds}`);
			},
			choseIt(item) {
				// console.log(item.goodsId,3)
				let i = this.selList.indexOf(item.goodsId);

				if (i === -1) {
					this.selList.push(item.goodsId);
					this.carIds.push(item.id);
					this.allSelect = this.selList.length == this.list.length;
				} else {
					this.selList.splice(i, 1);
					this.carIds.splice(i, 1);
					this.allSelect = false;
				}
			},
			choose() {
				this.allSelect = !this.allSelect
				if (this.selList.length >= this.list.length) {
					this.selList = []
					this.carIds = []
				} else {
					this.selList = []
					for (let i = 0; i < this.list.length; i++) {
						this.selList.push(this.list[i].goodsId);
						this.carIds.push(this.list[i].id)
						// console.log(this.list[i].goods.realPrice,222)

					}
				}

				// if (i === -1) {
				//   this.selList.push(id);
				//   this.allSelect = this.selList.length == this.list.length;
				// } else {
				//   this.selList.splice(i, 1);
				//   this.allSelect = false;
				// }
			},
			selAll() {
				this.$post({
					url: "/portal/Shop",
					module: "Cart",
					interface: "1001",
					data: {},
				}).then((res) => {
					console.log("推荐图", res);
					this.list = res.list;
					this.tips = res.tip;
				});
				// if (this.allSelect) {
				//   this.selList = [];
				//   this.allSelect = false;
				// } else {
				//   this.selList = this.list.map((item) => item.id);
				//   this.allSelect = true;
				// }
			},
			del(id) {
				this.$dialog
					.confirm({
						title: "删除商品",
						message: "您确定删除此商品吗？",
						cancelButtonText: "取消",
						confirmButtonText: "删除",
						cancelButtonColor: "#1677FF",
						confirmButtonColor: "#1677FF",
						className: "confirm-dialog",
					})
					.then(() => {
						this.$toast("删除" + id);
						this.$post({
							url: "/portal/Shop",
							module: "Cart",
							interface: "2003",
							data: {
								id: id
							},
						}).then((res) => {
							console.log("推荐图", res);
							this.selAll()
							// this.list = res.list;
						});
					})
					.catch(() => {});
			},
		},
	};
</script>

<style lang='less' scoped>
	.buy-car {
		height: calc(100vh - 50px);
		background: #f8f8f8;
		position: relative;
		padding-bottom: 36px;

		.icon {
			width: 22px;
			height: 22px;
		}

		.content {
			padding: 14px 16px 100px 16px;

			.list-item {
				border-radius: 8px;
				background-color: #fff;
				padding: 12px 12px 10px 8px;
				margin-bottom: 14px;

				.noShelves {
					display: inline-block;
					width: 22px;
					color: #fd0212;
					font-size: 12px;
				}

				&:last-child {
					margin-bottom: 0;
				}

				.product-icon {
					width: 88px;
					height: 88px;
					background: #f5f7f6;
					box-shadow: 0px 2px 4px 0px rgba(16, 16, 16, 0.1);
					border-radius: 8px;
					margin-left: 8px;
				}

				.right-box {
					display: flex;
					flex-direction: column;
					flex: 1;
					padding-left: 14px;

					p {
						flex: 1;

						&.title {
							font-size: 15px;
							color: #303133;
							margin-bottom: 6px;
							min-height: 44px;
						}

						&.price {
							font-size: 13px;
							color: #fd0212;
						}
					}

					.del {
						margin-left: auto;
					}
				}
			}
		}

		.bottom-bar {
			position: fixed;
			bottom: 50px;
			width: 100%;
			height: 35px;
			background: #ffffff;
			box-shadow: 0px 1px 0px 0px rgba(229, 229, 229, 1);
			display: flex;
			align-items: center;
			.carTips {
				color: #fd0212;
				font-size: 14px;
				position: absolute;
				top: -100%;
				left: 0;
				padding-left: 14px;
			}

			.flex-between {
				padding: 0 12px 0 14px;
				font-size: 12px;
				flex: 1;

				.grey-text {
					color: #999999;
					padding-left: 7px;
				}

				.red-text {
					font-size: 14px;
					color: #fd0212;
				}
			}

			.button {
				width: 100px;
				height: 35px;
				line-height: 36px;
				background: #fd0212;
				margin-left: auto;
				text-align: center;
				font-size: 13px;
				color: #ffffff;

				&:active {
					background: #e60211;
				}
			}
		}
	}
</style>
